var exports = {
  "zp": "LinkedAccountsTab.module__spinnerWrapper___b2ZvSE",
  "p$": "LinkedAccountsTab.module__emptyState___b2ZvSE",
  "G$": "LinkedAccountsTab.module__platformRow___b2ZvSE",
  "h5": "LinkedAccountsTab.module__platformIconButton___b2ZvSE",
  "_4": "LinkedAccountsTab.module__domainIcon___b2ZvSE",
  "eF": "LinkedAccountsTab.module__connectionsList___b2ZvSE",
  "Nr": "LinkedAccountsTab.module__card___b2ZvSE",
  "wy": "LinkedAccountsTab.module__cardDragging___b2ZvSE",
  "V7": "LinkedAccountsTab.module__cardDragHandle___b2ZvSE",
  "EF": "LinkedAccountsTab.module__cardIconSquircle___b2ZvSE",
  "Bj": "LinkedAccountsTab.module__cardInfo___b2ZvSE",
  "_O": "LinkedAccountsTab.module__cardName___b2ZvSE",
  "SI": "LinkedAccountsTab.module__cardNameRow___b2ZvSE",
  "vN": "LinkedAccountsTab.module__verificationBadge___b2ZvSE",
  "eB": "LinkedAccountsTab.module__cardActions___b2ZvSE",
  "hP": "LinkedAccountsTab.module__actionButton___b2ZvSE",
  "Il": "LinkedAccountsTab.module__dropIndicatorTop___b2ZvSE",
  "Yc": "LinkedAccountsTab.module__dropIndicatorBottom___b2ZvSE",
};

module.exports = exports;
